 export enum GridViewType
 {
     Grid = 1,
     OverviewWidget = 2,
     Dashboard = 3
 }